const DOWNLOADALLVOUCHER_UPDATED = (state, DownloadAllVoucher) => {
  state.DownloadAllVoucher = DownloadAllVoucher
}

export default {
  DOWNLOADALLVOUCHER_UPDATED
}
